import { useCallback, useEffect, useState, useContext } from "react";
import { FilterContext } from "../FilterContextProvider";
import { DateTime } from "luxon";
import useApi from "../Api/Api";

const useEventSales = (eventId, previousEventId) => {
  const { filterData } = useContext(FilterContext);
  const api = useApi();
  const [eventSales, setEventSales] = useState([]);
  const [previousEventSales, setPreviousEventSales] = useState([]);

  const getEventSales = useCallback(() => {
    filterData.artist_id &&
      api.get(`/sales/all?artist_id=${filterData.artist_id}&event_id=${eventId}`).then((r) => {
        setEventSales(r.data);
      });
  }, [api, filterData.artist_id, eventId]);

  const getPreviousEventSales = useCallback(() => {
    filterData.artist_id &&
      api.get(`/sales/all?artist_id=${filterData.artist_id}&event_id=${previousEventId}`).then((r) => {
        setPreviousEventSales(r.data);
      });
  }, [api, filterData.artist_id, previousEventId]);

  const noMatch = {
    count_out: 0,
  };

  eventSales.forEach((sale) => {
    const previousSale = previousEventSales.find(({ product_id }) => product_id === sale.product_id) || noMatch;
    sale.previous_count_out = previousSale.count_out;
  });

  useEffect(() => {
    getEventSales();
  }, [getEventSales]);

  useEffect(() => {
    getPreviousEventSales();
  }, [getPreviousEventSales]);

  eventSales
    .sort((a, b) => (DateTime.fromISO(a.product.created_at) > DateTime.fromISO(b.product.created_at) ? 1 : -1))
    .sort((a, b) => (a.size?.index < b.size?.index ? 1 : -1))
    .sort((a, b) => b.product_name?.localeCompare(a.product_name))
    .sort((a, b) => (a.category?.index > b.category?.index ? 1 : -1))
    .forEach((sale) => {
      const sold =
        sale.count_in +
        sale.add +
        sale.add_2 +
        sale.add_3 +
        sale.add_4 -
        sale.count_out -
        sale.damage_quantity -
        sale.band_comp_quantity -
        sale.ctm_comp -
        sale.management_comp -
        sale.mail_order -
        sale.discount_quantity;
      sale.sold = sold;
      sale.gross_sales = sold * sale.price;
      sale.discount_sales = sale.discount_quantity * sale.discount_price;
    });

  return {
    eventSales,
    setEventSales,
    getEventSales,
  };
};

export default useEventSales;
